import { RootState } from "redux/rootReducer";

export const selectIsVerifyOTP = (state: RootState) => state.verifyOTP.loading;
export const selectVerifyOTPErrorMessage = (state: RootState) =>
  state.verifyOTP.error;
export const verifyOTPDataResponse = (state: RootState) =>
  state.verifyOTP.verifyOTPResponse;
